export default "__VITE_ASSET__DZWSEubO__"